# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class FeaturedVideo extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'FeaturedVideoModule'
#
#   @selector: ".featured_video_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# FeaturedVideo.register()
